import { Heading } from "@/components/generic/Heading";
import { RadioCard } from "@/components/generic/RadioCard";
import { SalesStrat } from "@/types/campaign";
import { Text } from "react-aria-components";

export const SalesStrategyCard = ({ strategy }: { strategy: SalesStrat }) => (
  <RadioCard
    className="flex size-full flex-col items-center gap-y-6 rounded-lg p-6 xl:p-12"
    value={strategy.id}
    aria-label={strategy.label}
  >
    <div className="overflow-hidden">
      <img
        src={strategy.image}
        className="h-8 w-full object-cover object-left"
        alt={strategy.label}
      />
    </div>

    <div className="flex flex-col gap-4">
      <Heading
        className="text-theme-on-background text-[14px] font-bold"
        slot="description"
      >
        {strategy.label}
      </Heading>

      <Text
        className="text-theme-on-background text-[10px] font-bold"
        slot="description"
      >
        {strategy.description}
      </Text>
    </div>
  </RadioCard>
);
